/**
 * Named date-range presets. A preset is stored rather than the dates it covers,
 * so it re-resolves against the current date every time it is read.
 */
export const IDS = [
	'today',
	'yesterday',
	'last-7-days',
	'last-28-days',
	'last-30-days',
	'last-90-days',
	'last-12-months',
	'last-year',
	'this-month',
	'this-year',
] as const;
